import React, { useState, useEffect } from "react";
import Card from "./Card";
// import Pagination from '@mui/material/Pagination';
// import Footer from "../Footer/Footer";
import Pagination from "../Pagination/Pagination";
import { getMUICache, getUrl, appendStyleSheet, getEndpoint, fetchAnchorValue } from './../../common/utils';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { CacheProvider } from '@emotion/react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Typography from '@mui/material/Typography';
// import Link from '@mui/material/Link';
import "./webstories.css";
import { PAGEBUILDER_URLS } from "../Common/Constant";
import bcrypt from 'bcryptjs-react';

WebStories.version = 1000;

WebStories.lang = 'en';
WebStories.langs = [
    'en'
];
WebStories.setLang = (lang: any) => {
  WebStories.lang = lang;
}

Object.defineProperty(WebStories, 'name', {
  writable: true,
  value: 'WebStories'
});

function NextArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", right: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>
      <KeyboardArrowRightIcon fontSize='medium' />
    </div>
  );
}

function PrevArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", left: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>
      <KeyboardArrowLeftIcon fontSize='medium' />
    </div>
  );
}

export function WebStories(props: any) {
  const [cardListData, setCardListData] = useState<any>([]);
  const [currentPageData, setCurrentPageData] = useState<any>([]);
  const [paginationMetaData, setPaginationData] = useState<any>({});
  const [currentPageIndex, setCurrentPageIndex] = useState<any>(1);
  let styles = require("./webstories.css");
  appendStyleSheet("WebStories", styles);

  const {
    onClick,
    mobileView,
    showDateTime,
    showAuthorName,
    background,
    title,
    type1 = "page",
    MSID,
    showViewAll,
    viewAllUrl,
    isCarousel,
    isCircular,
    showAdSlot,
    anchorLinksValue
  } = props;

  const setData = (val: any) => {
    if (type1 == "page") {
      const obj: pageData = { page: 1, items: val?.items };
      setCardListData([obj]);
    } else {
      setCardListData(val?.items)
    }

    setCurrentPageData(val?.items);
    setPaginationData({ count: val?.pg?.tp })
  }

  const endpoint = getEndpoint(props);
  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, [MSID, endpoint, type1, showAdSlot]);

  if (endpoint.isSSR && endpoint.SSRDataObj
    && currentPageData && Object.keys(currentPageData).length === 0 && ( !cardListData || Object.keys(cardListData).length === 0 ) 
    && endpoint.SSRDataObj.pg && Object.keys(endpoint.SSRDataObj.pg).length != 0
    && endpoint.SSRDataObj.pg.tr != 'null' && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length != 0) {
    setData(endpoint.SSRDataObj);
  }

  const carouselRef = React.useRef(null);

  // let i_scrollMode = true;
  // if( props.scrollMode && props.scrollMode == props.CONSTANTS.SCROLL_MODE.MANUAL ) {
  //   i_scrollMode = false;
  // }

  interface pageData {
    page: number;
    items: any; // Replace YourItemType with the actual type of items
    // Add more properties as needed
  }

  const fetchComponentData = () => {
    setCardListData([])
    setCurrentPageIndex(1);
    setCurrentPageData([]);

    const url = getUrl(props);

    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = {'p-nonce': headerString};
    
    fetch(url, { headers: headers })
      .then(data => data.json())
      .then(parsedData => {
        setData(parsedData);
      })
      .catch(error => {
        console.error("Error fetching data", error);
      });
  }

  const Carouselsettings = { 
    infinite: false,
    speed: 500,
    autoplay: false,
    slidesToShow: isCircular ? 9 : 4,
    slidesToScroll: props.scrollCount,
    initialSlide: 0,
    dots: isCircular ? false : true,
    arrows: isCircular ? true : false,
    swipeToSlide: true,
    variableWidth: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,


    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: props.scrollCount,
          variableWidth: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: props.scrollCount,
          dots:false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots:false,

        }
      }
    ]
  };

  const getCarousel = () => {
    return <div>
      <Slider {...Carouselsettings} ref={carouselRef}>
        {cardListData && renderCardList()}
      </Slider>
    </div>
  }

  const clearSSR = () => {
    endpoint.SSRDataObj = null;
  }

  const dataAvailable = (pageIndex: number) => {
    let currentDataAvailable = false;
    let currentData = [...cardListData];

    for (var i = 0; i < currentData.length; i++) {
      if (currentData[i].page == pageIndex) {
        return currentData[i].items;
      }
    }
    return currentDataAvailable;
  }

  const handlePaginationChange = (event: any, index: number) => {
    clearSSR();
    let isSelectedPageAvailable = dataAvailable(index);

    if (isSelectedPageAvailable) {
      setCurrentPageData(isSelectedPageAvailable);
    } else {
      getAnotherPageData(index, false);
    }
    setCurrentPageIndex(index);
  }

  const getAnotherPageData = (val: number, isLoadMore: boolean) => {
    let url = getUrl(props, val, isLoadMore);

    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = {'p-nonce': headerString};
    
    fetch(url, { headers: headers })
      .then(data => data.json())
      .then(value => {
        if (type1 == "page") {
          let obj: pageData = { page: val, items: value.items };

          setCardListData([...cardListData, obj])
          setCurrentPageData(value.items);
        } else {
          setCardListData([...cardListData, ...value.items])
          type1 == "load" ? setCurrentPageData([...cardListData, ...value.items]) : setCurrentPageData(value.items);
          setCurrentPageIndex(currentPageIndex + 1)
        }
      })
  }

  const handleNextBtnClick = () => {
    clearSSR();
    let dataLength = 5;

    if (cardListData.length >= (dataLength * currentPageIndex) + 1) {
      let currentpagedata = [...cardListData];
      var lastItemLenght = cardListData.length - (dataLength * currentPageIndex);
      if (lastItemLenght > 5) {
        lastItemLenght = 5;
      }
      let updatedArr = currentpagedata.splice((dataLength * currentPageIndex), lastItemLenght);
      setCurrentPageData(updatedArr);
      setCurrentPageIndex(currentPageIndex + 1)

    } else {
      getAnotherPageData(currentPageIndex + 1, false);
    }
  }

  const handlePrevBtnClick = () => {
    if (currentPageIndex == 1) {
      return;
    } else {
      clearSSR();
      let currentpagedata = [...cardListData];
      let dataLength = 5;
      let updatedArr = currentpagedata.splice(dataLength * (currentPageIndex - 2), dataLength);
      setCurrentPageData(updatedArr);
      setCurrentPageIndex(currentPageIndex - 1)
    }
  }

  const handleLoadMoreClick = () => {
    clearSSR();
    getAnotherPageData(currentPageIndex + 1, false)
  }

  const renderPagination = () => {
    return <Pagination
      type={type1}
      handlePaginationChange={handlePaginationChange}
      paginationMetaData={paginationMetaData}
      handleNextBtnClick={handleNextBtnClick}
      handlePrevBtnClick={handlePrevBtnClick}
      handleLoadMoreClick={handleLoadMoreClick}
      currentPageIndex={currentPageIndex}
    />
  }

  const renderGridView = () => {
    return <div>
      <div className="webstroiscaredwrapper">
        {currentPageData && currentPageData.length && renderCardList()}
      </div>
      {paginationMetaData.count && renderPagination()}
    </div>
  }

  const handleCarouselAdSlot = (data: any) => {
    let updatedArr = [];

    for(var i=0; i<data.length; i++) {
      if(i != 0 && i % 3 == 0) {
        updatedArr.push("")
      }
      updatedArr.push(data[i])
    }

    return updatedArr;
  }

  const renderCardList = () => {
    if (!Array.isArray(currentPageData)) {
      console.error('currentPageData is not an array or is undefined');
      return [];
    }
    const listData = [];
    let renderData = [...currentPageData];

    if (renderData.length >= 3 && showAdSlot && !isCarousel) {
      renderData.splice(2, 0, "")
    }

    if(renderData.length && isCarousel && showAdSlot) {
      renderData = handleCarouselAdSlot(renderData)
    }

    let bodySnippet: any;
    if (typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
      bodySnippet = '<div class="container" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background-color: #f0f0f0;"><div class="ad-box" style="width: 266px;height: 334px;display: flex;align-items: center;justify-content: center;">Ad Slot<br>266 X 334</div></div>'
    } else {
      bodySnippet = props.bodyAdScript;
    }

    for (let i = 0; i < renderData.length; i++) {
      if (renderData[i] == "") {
        //const className = ("mh-10" + i) + (!isCarousel ? " card-items" : " quickview_main_wrap");
        const Id = "ad-grid-" + currentPageIndex + "_" + i;
        listData.push(<div key={i} id={Id} dangerouslySetInnerHTML={{ __html: bodySnippet }}></div>)
      } else {
        listData.push(<Card
          item={renderData[i]}
          showDateTime={showDateTime}
          mobileView={mobileView}
          showAuthorName={showAuthorName}
          background={background}
          key={i}
          isCarousel={isCarousel}
          CONSTANTS={props.CONSTANTS}
          anchorLinksValue={anchorLinksValue}
        />)
      }
    }

    return listData;
  }

  return (
    <div className={`card_wrapper ${isCircular ? "circular" : ""}`} onClick={onClick}>
      <CacheProvider value={getMUICache()}>
        <div className="headingRow">
          <h3 className=""><a>{title}</a></h3>
          <span className="">{showViewAll && <a href={viewAllUrl} target={fetchAnchorValue(anchorLinksValue, viewAllUrl)} className="showAll">View All</a>}</span>
        </div>
        <div>
          {isCarousel ? getCarousel() : renderGridView()}
        </div>
      </CacheProvider>
    </div>
  );
}
